import { useEffect } from "react";
import { trackMarketingEvent } from "@/lib/marketingAnalytics";

function classifyLink(href) {
  if (!href) return null;
  if (href.includes("/tournaments")) return "tournament_interest";
  if (href.includes("/balatro") || href.includes("/chat")) return "yorick_interest";
  if (href.includes("/login")) return "signup_interest";
  if (href.includes("/leaderboard")) return "leaderboard_interest";
  return null;
}

export default function MarketingLinkTracker() {
  useEffect(() => {
    const handler = (event) => {
      const link = event.target?.closest?.("a[href]");
      if (!link) return;
      const eventName = classifyLink(link.getAttribute("href"));
      if (!eventName) return;
      trackMarketingEvent(eventName, {
        link_text: (link.textContent || "").trim().slice(0, 120),
        link_url: link.getAttribute("href"),
      });
    };

    document.addEventListener("click", handler, true);
    return () => document.removeEventListener("click", handler, true);
  }, []);

  return null;
}
